import { TypographyHeading } from "shared/molecules/typography-layout";
import { Nl3LiveclassPackagesFilter } from "./filter";
import { Box, InputLabel, Paper, Typography, FormControl, Select, MenuItem, Pagination, Button } from "@mui/material";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import { useEffect, useState } from "react";
import { GET_LIVECLASS_PACKAGES } from "utils/graphql/services/live-classes/queries";
import { useLazyQuery } from "@apollo/client";
import NoDataFound from "shared/molecules/no-data";
import {Stack} from "@mui/material"
import {table} from "./helper"
import liveClassClientService from "utils/graphql/liveclassClient";
import ContentRight from "shared/molecules/content-right";
import { Link} from "react-router-dom";
import { utcToIst } from "utils/time-util/utcIstTime";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";

export default function Nl3LiveclassPackages() {

    const [searchPayload, setSearchPayload] = useState({});
    const [page, setPage] = useState(1);
    const [clearValuesTrigger, setClearValuesTrigger] = useState(0);
    const [limit, setLimit] = useState(10);

    const [Nl3LiveclassPackagesList, { loading,error, data }] = useLazyQuery(
        GET_LIVECLASS_PACKAGES,
        {
            client: liveClassClientService,
        },
    );

    useEffect(() => {
        Nl3LiveclassPackagesList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    ...searchPayload,
                },
            },
        });
    }, [page, limit, searchPayload]);

   const nl3LiveClassPackagesData =
                 data?.getLiveclassPackages?.liveclassPackages?.map((item: any) => ({
                     ...item,
                     packageStudentsCount: String(item.packageStudentsCount),
                     createdAt: utcToIst(item.createdAt),
                     updatedAt: utcToIst(item.updatedAt),
                 })) || [];

    return (
        <>
             <ContentRight>
                <Link to="/live-classes/liveclass-packages/create" >
                    <Button variant="contained">Create Liveclass Package</Button>
                </Link>
            </ContentRight>

            <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
                Liveclass Packages{" "}
            </TypographyHeading>

            
            <Nl3LiveclassPackagesFilter
                setSearchPayload={setSearchPayload}
                setPage={setPage}
                clearValuesTrigger={clearValuesTrigger}
            />

            <Paper elevation={2} sx={{ p: 2, mt: 3 }}>

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <FormControl size="small" sx={{ width: 140 }}>
                        <InputLabel>Show Entries</InputLabel>
                        <Select
                            value={limit}
                            label="Show Entries"
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1); // reset to first page
                            }}
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <div>
                    {loading && <Loader />}
                    {!loading && data?.getLiveclassPackages?.liveclassPackages?.length > 0 ? (
                        <CollapsibleTable
                            data={nl3LiveClassPackagesData || []}
                            table={table}
                            id="id"
                            name="id"
                            rowsPerPageCount={limit}
                            style="false"
                            totalRecords={data?.getLiveclassPackages?.totalCount || 0}
                            paginationSegmentApi="false"
                            viewSecondaryData="false"
                            showPaginationFooter={false}
                        />
                    ) : (
                        <div>{!loading && <NoDataFound message="No Data Found" />}</div>
                    )}
                </div>

                <Box sx={{ marginTop: "20px" }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Pagination
                            count={Math.ceil(data?.getLiveclassPackages?.totalCount / limit) || 1}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            size="medium"
                        />
                    </Stack>
                </Box>

            </Paper>
        </>
    )
}